export const PhoneMockup = ({ src, alt, testId = "hero-phone-mockup", eager = false, compact = false }) => (
    <div
        data-testid={testId}
        className={`relative rounded-[44px] border border-[#2A2C27] bg-[#1D201A] p-[10px] shadow-[0_48px_90px_-48px_rgba(29,32,26,0.45)] ${
            compact ? "w-[210px] sm:w-[230px]" : "w-[270px] sm:w-[300px]"
        }`}
        role="img"
        aria-label={alt}
    >
        <img
            src={src}
            alt=""
            className="block h-auto w-full rounded-[34px]"
            loading={eager ? "eager" : "lazy"}
        />
    </div>
);
